import React from "react";
import { VehicleSpecificationForm } from "./VehicleSpecificationForm";
import { useVehicleSpecificationContext } from "./vehicleSpecificationContext";
import "./VehicleSpecification.scss";
import { Panel, useIwaContext, } from "@cognitranlimited/itis-web";
import { useGetVehicleSpecificationMatrixQuery } from "./vehicleSpecificationApi";
var VehicleSpecificationCard = function (_a) {
    var closeTab = _a.closeTab, document = _a.document;
    var searchParams = new URLSearchParams(window.location.search);
    var vehicle = useIwaContext().vehicle;
    var _b = useGetVehicleSpecificationMatrixQuery({
        vehicleCode: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.ref) === "product" ? vehicle === null || vehicle === void 0 ? void 0 : vehicle.productVariantId : "",
        documentSourceId: document.sourceId,
    }, { skip: !Boolean(vehicle === null || vehicle === void 0 ? void 0 : vehicle.code) }), productVariantData = _b.data, isLoading = _b.isLoading, isUninitialized = _b.isUninitialized;
    if (searchParams.get("parameters")) {
        closeTab();
    }
    var strings = useVehicleSpecificationContext().strings.vehicleSpecification;
    if (!/products\/\d+\//.test(window.location.pathname) ||
        (document.id && vehicle && (!(vehicle === null || vehicle === void 0 ? void 0 : vehicle.code) || vehicle.ref === "vin"))) {
        closeTab();
        return null;
    }
    if (isUninitialized || isLoading)
        return null;
    if (!productVariantData || productVariantData.length === 0) {
        closeTab();
        return null;
    }
    return (React.createElement(Panel, { className: "VehicleSpecificationCard" },
        React.createElement(Panel.Header, { title: strings.title }),
        React.createElement(Panel.Content, null,
            React.createElement(VehicleSpecificationForm, { closeTab: closeTab, document: document, productVariantData: productVariantData }))));
};
export { VehicleSpecificationCard };
